module.exports = __webpack_public_path__ + "img/img_03.df9ea069.png";